import { Action, Method, NO_VALUE } from '../../constants.js';
export const buildSuccessResetPasswordPayload = (payloadParams) => {
    const { loginSource } = payloadParams;
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            linkName: `resetPasswordSuccessMessageVisible`,
            componentId: 'candidateLoginPage',
        },
        trackingData: {
            allowLinkBeforeView: true,
            elementActioned: 'resetPasswordSuccessMessage',
            loginSource: loginSource,
            componentState: NO_VALUE,
            elementAction: Action.VISIBLE,
            elementActionValue: NO_VALUE,
        },
    };
    return trackingPayload;
};
//# sourceMappingURL=buildSuccessResetPassword.js.map